import { createFileRoute } from '@tanstack/react-router';
import ReviewTopicsPage from '@/pages/(protected)/workspaces/[workspaceId]/review-topics';
import { z } from 'zod/v3';

const reviewTopicsSearchSchema = z.object({
  flowId: z.string(),
  jobId: z.string(),
});

export const Route = createFileRoute('/(protected)/workspaces/$workspaceId/review-topics')({
  component: ReviewTopicsPage,
  validateSearch: reviewTopicsSearchSchema,
}); 